export enum DealroomQueryKey {
  Directories = 'dsrDirectoriesV2',
  Resources = 'dsrResources',
}
